/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Chanakya',
        title: 'Chanakya Niti',
        text: "कुए में उतरने वाली बाल्टी यदि झुकती है, तो भरकर बाहर आती है। जीवन का भी यही गणित है,जो झुकता है वो ही ज्ञान प्राप्त करता है।",
        image: boy2
    },
    {
        id: 2,
        name: 'Chanakya',
        title: 'Chanakya Niti',
        text: "सीखते समय, व्यापार में बातचीत करते हुए, और भोजन करते समय आपको बेशर्म होना चाहिए।",
        image: boy2
    },
    {
        id: 3,
        name: 'ए.पी.जे. अब्दुल कलामy',
        title: 'महान लेखक व वैज्ञानिक',
        text: "सफलता की कहानियां मत पढ़ो उससे आपको केवल एक सन्देश मिलेगा। असफलता की कहानियां पढ़ो उससे आपको सफल होने के कुछ आइडियाज (विचार) मिलेंगे। :)",
        image: girl1
    },
    {
        id: 4,
        name: 'ए.पी.जे. अब्दुल कलाम',
        title: 'महान लेखक व वैज्ञानिक',
        text: " आत्मविश्वास और कड़ी मेहनत, असफलता नामक बिमारी को  मारने के लिए सबसे बढ़िया दवाई है। ये आपको एक सफल व्यक्ति बनाती है।",
        image: boy1
    },
    {
        id: 5,
        name: 'Rachel Green',
        title: 'Sales Executive',
        text: '. सपने वो नहीँ जो हम सोते हुये देखते है, सपने वो है जो हमे सोने नहीँ देते',
        image: girl3
    },
    {
        id: 6,
        name: 'Ross Geller',
        title: 'Paleontologist',
        text: "इंतज़ार करने वालो को सिर्फ उतना ही मिलता है, जितना कोशिश करने वाले छोड़ देते है। ",
        image: boy3
    }
]

